// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { initializeFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAnalytics } from "firebase/analytics";
import { getDatabase } from "firebase/database";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Firebase configuration - read from environment variables (see .env.example)
// instead of being hard-coded in the source.
const firebaseConfig = {
  apiKey:            import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain:        import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  databaseURL:       import.meta.env.VITE_FIREBASE_DATABASE_URL,
  projectId:         import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket:     import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId:             import.meta.env.VITE_FIREBASE_APP_ID,
};

const missingFirebaseKeys = Object.entries(firebaseConfig)
  .filter(([, v]) => !v)
  .map(([k]) => k);
if (missingFirebaseKeys.length > 0) {
  console.error(
    "[firebase] Missing environment variables for: " + missingFirebaseKeys.join(", ") +
    ". Copy .env.example to .env, fill in the VITE_FIREBASE_* values, and restart the dev server / rebuild."
  );
}

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const analytics = getAnalytics(app);
// experimentalAutoDetectLongPolling: some networks/ISPs/proxies buffer or block
// Firestore's streaming (WebChannel) connection, which leaves the first
// snapshot hanging for a long time before the SDK gives up on it. With
// auto-detect the SDK notices quickly and switches to long-polling instead.
const db = initializeFirestore(app, { experimentalAutoDetectLongPolling: true });
const storage = getStorage(app);
export const auth = getAuth(app);

// Realtime Database is ONLY used by booking/reservation/hold code
// (src/components/booking/firebase/*, slotAvailability.js, paymentProof.js,
// the admin ReservationsPanel). Every other page in the app - Home, Gallery,
// Blog, About, etc. - imports `db`/`auth` from this same file for Firestore,
// so calling getDatabase(app) unconditionally at module load meant EVERY
// page opened an RTDB WebSocket/long-poll connection whether it needed one
// or not. That's what was showing up as connection-timeout / deprecated
// long-polling-API warnings across the whole site.
//
// Making it a lazy singleton means the connection is only opened the first
// time a booking-related module actually calls getRtdb().
let _rtdb = null;
export function getRtdb() {
  if (!_rtdb) _rtdb = getDatabase(app);
  return _rtdb;
}

export { db, storage };